import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface SettingsSectionProps {
  children: ReactNode;
  title: string;
}

export const SettingsSection = ({ children, title }: SettingsSectionProps) => (
  <div className="grid grid-cols-[auto_1fr] items-center gap-x-2 px-3 py-1.5">
    <div className="text-left">
      <Typography variant="label-sm" color="primary">
        {title}
      </Typography>
    </div>
    <div className="justify-self-end max-w-full shrink-0">{children}</div>
  </div>
);
